import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ScanProviderBinding,
  ScanProviderBindingPost,
  ScanProviderBindingPut,
} from '../common/ScanProviderBinding';
import { CategoryResolutionProfile } from '../common/CategoryResolutionProfile';
import { VatResolutionProfile } from '../common/VatResolutionProfile';
import { ScanRun } from '../common/ScanRun';
import { ApiServiceBase } from './ApiServiceBase';

@Injectable({
  providedIn: 'root',
})
export class ScanProviderBindingService extends ApiServiceBase {
  protected readonly path = 'scanproviderbindings';

  get(customerId?: string): Observable<ScanProviderBinding[]> {
    return this.http
      .get<ScanProviderBinding[]>(this.getUrl(), {
        params: customerId ? { customerId } : {},
      });
  }

  getById(id: string): Observable<ScanProviderBinding> {
    return this.http
      .get<ScanProviderBinding>(this.getUrl() + '/' + id);
  }

  create(binding: ScanProviderBindingPost): Observable<ScanProviderBinding> {
    return this.http
      .post<ScanProviderBinding>(this.getUrl(), binding);
  }

  update(id: string, binding: ScanProviderBindingPut): Observable<ScanProviderBinding> {
    return this.http
      .put<ScanProviderBinding>(this.getUrl() + '/' + id, binding);
  }

  delete(id: string): Observable<void> {
    return this.http
      .delete<void>(this.getUrl() + '/' + id);
  }

  // 202 Accepted: the scan is enqueued, the returned run starts out Queued.
  triggerNow(id: string): Observable<ScanRun> {
    return this.http
      .post<ScanRun>(this.getUrl() + '/' + id + '/trigger-now', null);
  }

  getScanRuns(id: string, take: number = 50): Observable<ScanRun[]> {
    return this.http
      .get<ScanRun[]>(this.getUrl() + '/' + id + '/scan-runs', { params: { take } });
  }

  // Backend #538: the named category-resolution profiles a binding may reference — the
  // dropdown source for categoryResolutionProfileKey.
  getResolutionProfiles(): Observable<CategoryResolutionProfile[]> {
    return this.http
      .get<CategoryResolutionProfile[]>(this.getUrl() + '/resolutionprofiles');
  }

  // Backend #579 (slice 4): the named VAT-resolution profiles a binding may reference — the
  // dropdown source for vatResolutionProfileKey.
  getVatResolutionProfiles(): Observable<VatResolutionProfile[]> {
    return this.http
      .get<VatResolutionProfile[]>(this.getUrl() + '/vatresolutionprofiles');
  }
}
